module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Couch-26e65f1cde1d7165cac9ce5b5233498a.svg";